import BaseComponent from '../../../../../common/js/BaseComponent';

export default class DesktopNav extends BaseComponent {
    init(): any {
        this.initNavItemEvt();
        this.initNavCloseEvt();
        this.initOverlayHoverEvt();
    }

    initNavItemEvt() {
        const items = this.view.querySelectorAll('.nav-item');
        items?.forEach((item) => {
            item.addEventListener('mouseover', () => {
                item.classList.add('hover');
            });
            item.addEventListener('mouseout', () => {
                item.classList.remove('hover');
            });
        });
    }

    initNavCloseEvt() {
        const btnClose = this.view.querySelectorAll('.meganav .close');
        btnClose?.forEach((close) => {
            close.addEventListener('click', () => {
                close.closest('.nav-item')?.classList.remove('hover');
            });
        });
    }

    initOverlayHoverEvt() {
        const overlays = this.view.querySelectorAll('.overlay');
        overlays?.forEach((overlay) => {
            overlay.addEventListener('mouseover', (e) => {
                overlay.closest('.nav-item')?.classList.remove('hover');
                e.stopPropagation();
            });
        });
    }
}
